import { gql } from '@apollo/client'

export const chatGetSuggestions = gql`
  query ChatGetSuggestions {
    chatGetSuggestions
  }
`
